module.exports = __webpack_public_path__ + "static/media/message4.15fcd86a.png";